import React from 'react'
import PropTypes from 'prop-types'

const SelectFieldItem = ({ item, isFocused, handleOnClick }) => (
  <li
    tabIndex="-1"
    data-focused={isFocused}
    data-focus-key={item.focusKey}
    onClick={() => handleOnClick(item)}
  >
    {item.label ? item.label : item.key}
  </li>
)

SelectFieldItem.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    focusKey: PropTypes.string,
  }),
  handleOnClick: PropTypes.func,
  isFocused: PropTypes.bool,
}

export default SelectFieldItem
